export function classNameForValidationErrors(field) {
    if (field.error && field.touched) {
        return "idea-attribute--required";
    }

    return "";
}


/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/components/componentUtils.js
 **/